<template>
  <div class="spl-header-drawer__section__search">
    <input
      v-model="inputValue"
      type="text"
      name="searchquery"
      placeholder="Search…"
      @keyup.enter="Search">
    <form-button
      secondary="true"
      @onClick="resetSearch">
      {{ resetLabel }}
    </form-button>
    <form-button
      :disabled="inputValue === ''"
      @onClick="Search">
      Search
    </form-button>
  </div>
</template>

<script>
export default {
  name: 'HeaderSearch',
  props: [
    'dark',
    'closeSearch',
    'inline',
    'label'
  ],
  data () {
    return {
      inputValue: this.$route.query.search
    }
  },
  computed: {
    resetLabel () {
      return this.inputValue === '' ? 'Cancel' : 'Reset'
    }
  },
  methods: {
    resetSearch () {
      if (this.inputValue === '') {
        this.closeSearch()
      } else {
        this.inputValue = ''
      }
      this.$router.replace('/parcel-list')
    },
    Search () {
      if (this.inputValue === '') {
        this.$router.replace('/parcel-list')
        this.closeSearch()
      } else {
        // Calls the parcel list with search
        this.$router.replace('/parcel-list?search=' + encodeURIComponent(this.inputValue))
        this.$emit('search_Clicked', this.inputValue)
      }
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-header-drawer__section__search {
        height: $headerHeight;

        @include mobile() {
            height: 60px;
            position: relative;
        }
        &__close {
            background-image: url(../../assets/icon-close.svg);
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 18px 18px;
            cursor: pointer;
            height: 60px;
            opacity: 1;
            position: absolute;
            right: 0;
            top: 0;
            transition: opacity $shortTransition ease-in-out;
            width: 60px;

            &-faded {
                opacity: 0.5;
            }
        }
        input[type="text"] {
            background-color: transparent;
            border: none;
            color: $headerNavHoverColor;
            font-family: $opensans;
            font-size: 30px;
            font-weight: 400;
            height: $headerHeight;
            line-height: $headerHeight;
            padding-left: $mainPadding;
            width: calc(100% - 260px);

            @include mobile() {
                font-size: 18px;
                height: 60px;
                line-height: 60px;
                padding-left: $mobilePadding;
                width: 100%;
            }
            &::-webkit-input-placeholder {
                color: $headerSearchColor;
            }
            &::-moz-placeholder {
                color: $headerSearchColor;
            }
            &:-ms-input-placeholder {
                color: $headerSearchColor;
            }
            &:-moz-placeholder {
                color: $headerSearchColor;
            }
        }
        .spl-button {
            margin-top: 15px;
            vertical-align: top;
        }
    }
</style>
